export class HistoryVariantAddController {
  public variantSchemaFields: any;
  public variantBaseFields: any;
  public variant: any;
  public variantDetail: any;

  constructor() {
    this.variant = angular.fromJson(this.variantDetail);

    this.variantBaseFields = {
      name: this.variant.name,
      description: this.variant.description,
      retailReference: this.variant.retailReference,
      price: this.variant.price
    };

    this.variantSchemaFields = this.variant.fields;
  }
}